module.exports = "/images/vendor/flag-icon-css/flags/1x1/un.svg?e6aabbd55ef6e4b38398d11e86733867";